export const getNavigationUrl = (url) => {
  if (!url) return '/';

  let normalizedUrl = String(url).trim();

  if (normalizedUrl.startsWith('http://') || normalizedUrl.startsWith('https://')) {
    try {
      const parsed = new URL(normalizedUrl);
      normalizedUrl = `${parsed.pathname}${parsed.search}${parsed.hash}` || '/';
    } catch {
      normalizedUrl = '/';
    }
  }

  if (normalizedUrl.startsWith('/our-work/')) {
    const section = normalizedUrl.split('/')[2];

    if (
      ['sectors', 'services', 'projects', 'competences', 'collaborators'].includes(section)
    ) {
      return `/our-work?section=${section}`;
    }
  }

  return normalizedUrl || '/';
};

export const handleBackClick = (e, onBackClick, goBackUrl, history) => {
    e.preventDefault();

    if (onBackClick) {
      onBackClick();
      return;
    }

    if (goBackUrl) {
      if (history) {
        history.goBack();
      } else {
        window.location.href = goBackUrl;
      }
      return;
    }

    if (typeof window === 'undefined') {
      return;
    }

    if (window.history.length > 1) {
      window.history.back();
    } else if (history) {
      history.push('/');
    } else {
      window.location.href = '/';
    }
  };
